import React, { useContext, useEffect, useRef, useState } from "react";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Dashboards/Dashboard.css";
import DashboardState from "./DashboardState";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";
import ManageDashboardStates from "./ManageDashboardStates.jsx";
import EditWidget from "../../../Widgets/EditWidget.jsx";
import { DashboardContext } from "./DashboardProvider.jsx";
import NavigationBar from "../../../navigation_components/NavigationBar.jsx";
import TenantAdministratorSideBar from "../../../sidebar_components/TenantAdministratorSideBar.jsx";
import NewVerticalCylinderTankWidget from "../../../Widgets/LiquidLevel/Widgets/NewVerticalCylinderTankWidget.jsx";
import { AppContext } from "../../../AppProvider.jsx";
import { useParams } from "react-router-dom";
import {WidgetRenderDelays} from "../../../Widgets/WidgetRenderDelays.js";
import WidgetsLibrary from "../../../Widgets/WidgetsLibrary.jsx";
import NewLineChartWidget from "../../../Widgets/Charts/Widgets/NewLineChartWidget.jsx";
import NewBarChartWidget from "../../../Widgets/Charts/Widgets/NewBarChartWidget.jsx";
import VerticalCylinderTankWidget from "../../../Widgets/LiquidLevel/Widgets/VerticalCylinderTankWidget.jsx";
import LineChartWidget from "../../../Widgets/Charts/Widgets/LineChartWidget.jsx";
import BarChartWidget from "../../../Widgets/Charts/Widgets/BarChartWidget.jsx";
import NewStateNavigationButtonWidget from "../../../Widgets/Buttons/widgets/NewStateNavigationButtonWidget.jsx";
import NewRadialGaugeWidget from "../../../Widgets/AnalogueGauges/widgets/NewRadialGaugeWidget.jsx";
const Dashboard = () =>{
    const {
        dashboard,
        setDashboard,
        editMode,setEditMode,
        showWidgetsLibrary,setShowWidgetsLibrary,
        dashboardStates,setDashboardStates,
        showManageDashboardStates,setShowManageDashboardStates,
        showNewDashboardState,setShowNewDashboardState,
        selectedEditDashboardState, setSelectedEditDashboardState,
        showEditDashboardState, setShowEditDashboardState,
        activeDashboardState,setActiveDashboardState,
        setActiveEditWidget,activeEditWidget,
        maximizedWidget,setMaximizedWidget,
        refreshDashboardState
    } = useContext(DashboardContext);
    const {user} = useContext(AppContext);
    const { tenantId, dashboardId } = useParams();
    const initialRender = useRef(true);
    const fetchAndSetDashboard = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${tenantId}/dashboards/${dashboardId}`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Authorization':`Bearer ${user.access_token}`,
                    'Content-Type':'application/json'
                }
            });
            if(response.ok){
                const responseData = await response.json();
                setDashboard(responseData);
            }
            else throw new Error(`Error code: ${response.status}`);
        }
        catch(error){
            console.error(`An error occurred when fetching dashboard with id: ${dashboardId} from the server`,error);
        }
    };
    const extractDashboardTimeWindowHeader = () =>{
        if(!dashboard?.timeWindow || dashboard.timeWindow?.history?.historyType === undefined) return '';
        if(dashboard.timeWindow.selectedTab === 0){
            if(dashboard.timeWindow.history.historyType === 0){
                switch(dashboard.timeWindow.history?.timeWindowMs){
                    case 1000:
                        return 'Realtime - Last 1 second';
                    case 5000:
                        return 'Realtime - Last 5 seconds';
                    case 10000:
                        return 'Realtime - Last 10 seconds';
                    case 15000:
                        return 'Realtime - Last 15 seconds';
                    case 30000:
                        return 'Realtime - Last 30 seconds';
                    case 60000:
                        return 'Realtime - Last 1 minute';
                    case 120000:
                        return 'Realtime - Last 2 minutes';
                    case 300000:
                        return 'Realtime - Last 5 minutes';
                    case 600000:
                        return 'Realtime - Last 10 minutes';
                    case 900000:
                        return 'Realtime - Last 15 minutes';
                    case 1800000:
                        return 'Realtime - Last 30 minutes';
                    case 3600000:
                        return 'Realtime - Last 1 hour';
                    case 7200000:
                        return 'Realtime - Last 2 hours';
                    case 18000000:
                        return 'Realtime - Last 5 hours';
                    case 36000000:
                        return 'Realtime - Last 10 hours';
                    case 43200000:
                        return 'Realtime - Last 12 hours';
                    case 86400000:
                        return 'Realtime - Last 1 day';
                    case 604800000:
                        return 'Realtime - Last 7 days';
                    case 2592000000:
                        return 'Realtime - Last 30 days';
                    default:
                        return '';
                }
            }
        }
        else if(dashboard.timeWindow.selectedTab === 1){
            if(dashboard.timeWindow.history.historyType === 0){
                switch(dashboard.timeWindow.history?.timeWindowMs){
                    case 60000:
                        return 'History - last second';
                    case 300000:
                        return 'History -last 5 seconds';
                    default:
                        return '';
                }
            }
        }
        return '';
    };
    const updateDashboard = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${tenantId}/dashboards/${dashboardId}`;
            const response = await fetch(url,{
                method:'PUT',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                },
                body:JSON.stringify(dashboard)
            });
            if(response.ok){
                const responseData = await response.json();
                setDashboard(responseData);
            }
            else throw new Error(`Response code: ${response.status}`);
        }
        catch(error){
            console.error('An error occurred when updating dashboard',error);
        }
    };
    useEffect(() =>{
        document.title = 'Blink IOT | Dashboard';
        return () =>{
            setEditMode(false);
            setDashboard(null);
            setMaximizedWidget(null);
            setActiveDashboardState(null);
        };
    },[]);
    useEffect(() =>{
        if(!dashboard) return;
        if(!activeDashboardState){
            dashboard?.dashboardStates?.forEach((dashboardState) =>{
                if(dashboardState.rootState) setActiveDashboardState(dashboardState);
            });
        }
        else if(refreshDashboardState.current){
            const matched = dashboard?.dashboardStates?.find(ds => ds?.id === activeDashboardState?.id);
            if (matched) setActiveDashboardState(matched);
            const totalExpectedDelay = matched?.widgets?.reduce((sum,widget) =>{
                return sum + (WidgetRenderDelays[widget?.type]?? 1);
            },0);
            requestAnimationFrame(() => {
                setTimeout(() => {
                    refreshDashboardState.current = false;
                }, totalExpectedDelay);
            });
        }
    },[dashboard]);
    useEffect(() =>{
        fetchAndSetDashboard();
    },[tenantId,dashboardId]);
    useEffect(() =>{
        setActiveEditWidget(null);
        if(initialRender.current){
            initialRender.current = false;
            return;
        }
        const disableEditMode = async() =>{
            if(!refreshDashboardState.current){
                refreshDashboardState.current = true;
                await fetchAndSetDashboard();
            }
        }
        if(!editMode) disableEditMode();
    },[editMode]);
    return(
        <div>
            {maximizedWidget? (
                <div>
                    {(() =>{
                        switch(maximizedWidget?.widget?.type)
                        {
                            case 'vertical_cylinder_tank':
                                return (
                                    <div key={maximizedWidget?.widget?.id}>
                                        <VerticalCylinderTankWidget
                                            key={maximizedWidget?.widget?.id}
                                            DashboardContext={DashboardContext}
                                            widget={maximizedWidget?.widget}
                                            setWidgets={maximizedWidget?.setWidgets}
                                            bounds={maximizedWidget?.bounds}
                                            setDraggingOrResizing={maximizedWidget?.setDraggingOrResizing}
                                            MOBILE_COMPUTER_SCREEN_BOUNDARY={maximizedWidget?.MOBILE_COMPUTER_SCREEN_BOUNDARY}
                                        />
                                    </div>
                                );
                            case 'line_chart':
                                return (
                                    <div key={maximizedWidget?.widget?.id}>
                                        <LineChartWidget
                                            key={maximizedWidget?.widget.id}
                                            DashboardContext={DashboardContext}
                                            widget={maximizedWidget?.widget}
                                            setWidgets={maximizedWidget?.setWidgets}
                                            bounds={maximizedWidget?.bounds}
                                            setDraggingOrResizing={maximizedWidget?.setDraggingOrResizing}
                                            MOBILE_COMPUTER_SCREEN_BOUNDARY={maximizedWidget?.MOBILE_COMPUTER_SCREEN_BOUNDARY}
                                        />
                                    </div>
                                );
                            case 'bar_chart':
                                return (
                                    <div key={maximizedWidget?.widget?.id}>
                                        <BarChartWidget
                                            key={maximizedWidget?.widget.id}
                                            DashboardContext={DashboardContext}
                                            widget={maximizedWidget?.widget}
                                            setWidgets={maximizedWidget?.setWidgets}
                                            bounds={maximizedWidget?.bounds}
                                            setDraggingOrResizing={maximizedWidget?.setDraggingOrResizing}
                                            MOBILE_COMPUTER_SCREEN_BOUNDARY={maximizedWidget?.MOBILE_COMPUTER_SCREEN_BOUNDARY}
                                        />
                                    </div>
                                );
                        }
                    })()
                    }
                </div>
            ):(
                <div className="tenant-admin-dashboard-page">
                    <NavigationBar/>
                    <div className="tenant-admin-dashboard-page-layout">
                        <div>
                            <TenantAdministratorSideBar/>
                        </div>
                        <div className="tenant-admin-dashboard-parent-container">
                            <div className="tenant-admin-dashboard-container">
                                <div className="tenant-admin-dashboard-content-container">
                                    <div className={`tenant-admin-dashboard-controls-parent-container ${showWidgetsLibrary? 'shrink':''}`}
                                        style={{visibility:activeEditWidget? 'hidden':'visible'}}>
                                        <div className="tenant-admin-dashboard-header-controls-container left">
                                            <p style={{display:editMode? 'none':'block'}}>{dashboard?.title}</p>
                                            <button
                                                style={{display:`${editMode? "flex":"none"}`}}
                                                onClick={() => setShowManageDashboardStates(true)}>
                                                <span style={{fontSize:"20px",fontWeight:"bold",marginRight:"10px"}}>&#8801;</span>
                                                <span>States</span>
                                            </button>
                                        </div>
                                        <div className="tenant-admin-dashboard-header-controls-container right">
                                            <button
                                                style={{
                                                    display:`${editMode? "flex":"none"}`,
                                                    border:'1px solid white',padding:'2px 15px'
                                                }}
                                                onClick={() => setShowWidgetsLibrary(true)}>
                                                <span style={{fontWeight:"bold",fontSize:"20px",marginRight:"10px"}}>&#43;</span>
                                                <span>Add widget</span>
                                            </button>
                                            <button
                                                style={{display:editMode? 'flex':'none'}}>
                                                <img src={`${process.env.PUBLIC_URL}/images/clock-icon.png`}/>
                                                <span>Time window</span>
                                            </button>
                                            <button style={{display:`${editMode? "flex":"none"}`}}>
                                                <span style={{fontSize:"20px",fontWeight:"bold",marginRight:"10px"}}>&#9881;</span>
                                                <span style={{paddingTop:"2px"}}>Settings</span>
                                            </button>
                                            <div className="seperator" style={{display:editMode? 'block':'none'}}></div>
                                            <button onClick={() => setEditMode(false)}
                                                style={{display:`${editMode? "flex":"none"}`}}>
                                                <span style={{fontSize:"20px",fontWeight:"400",marginRight:"10px"}}>&#10006;</span>
                                                <span>Cancel</span>
                                            </button>
                                            <button 
                                                onClick={async() => {
                                                    refreshDashboardState.current = true;
                                                    await updateDashboard();
                                                    setEditMode(false);
                                                }}
                                                style={{
                                                    display:`${editMode? "flex":"none"}`,
                                                    border:'1px solid white',padding:'0px 15px',
                                                    paddingBottom:'2px'
                                                }}>
                                                <span style={{marginRight:"10px",fontWeight:"bold",fontSize:"18px"}}>&#10003;</span>
                                                <span style={{marginTop:"2px"}}>Save</span>
                                            </button>
                                            <button title="Edit time window"
                                                style={{display:editMode? 'none':'flex'}}>
                                                <img src={`${process.env.PUBLIC_URL}/images/clock-icon.png`}/>
                                                <span style={{marginLeft:'5px'}}>{extractDashboardTimeWindowHeader()}</span>
                                            </button>
                                            <button onClick={() => setEditMode(true)}
                                                style={{display:`${editMode? "none":"flex"}`,paddingTop:'5px',paddingBottom:'5px'}}>
                                                <span style={{marginRight:"5px"}}>&#9997;</span>
                                                <span>Edit mode</span>
                                            </button>
                                            <button className="export-icon"
                                                style={{display:editMode? 'none':'flex'}}>
                                                <img src={`${process.env.PUBLIC_URL}/images/export-icon.png`}/>
                                                <span style={{marginLeft:'5px'}}>Export</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div className={`tenant-admin-dashboard-state-container ${activeEditWidget? 'edit-widget':''}`}>
                                        <DashboardState/>
                                    </div>
                                </div>
                                <div className={`edit-widget-section ${activeEditWidget? 'active':'inactive'}`}>
                                    <EditWidget/>
                                </div>
                            </div>
                        </div>
                        <WidgetsLibrary/>
                    </div>
                    <ManageDashboardStates/>
                    <div>
                        <NewVerticalCylinderTankWidget/>
                        <NewLineChartWidget/>
                        <NewBarChartWidget/>
                        <NewStateNavigationButtonWidget/>
                        <NewRadialGaugeWidget/>
                    </div>
                </div>
            )}
        </div>
    );
};
export default Dashboard;